<script setup>
import {ref} from "vue";
import Swal from "sweetalert2";
import axios from "axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  currentValue: {
    type: String,
    required: true,
  },
  enableErrors: {
    type: Boolean,
    required: false,
    default: true,
  },
  refreshOnSuccess: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  }
});

const emit = defineEmits(['success', 'error']);

const value = ref(props.currentValue);
const showInput = ref(false);
const savingInProgress = ref(false);

const save = async () => {
  savingInProgress.value = true;

  try {
    await axios.post(props.url, {
      value: value.value
    })
    emit('success', value.value);
    if (props.refreshOnSuccess) {
      window.location.reload();
    }
  } catch (error) {
    if (props.enableErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response.data.message,
        footer: 'If you are unsure what is happening, please contact the dev team.'
      })
    }
    emit('error', value.value);
  }

  savingInProgress.value = false;
  showInput.value = false;
};

</script>

<template>
  <div class="d-flex justify-content-end tailwind">
    <div
      v-if="showInput && !disabled"
      class="d-flex align-items-center border"
    >
      <input
        v-model="value"
        type="text"
        class="border-0"
      >
      <i
        v-if="savingInProgress"
        class="fa-solid fa-spinner fa-spin ml-1"
      />
      <template v-else>
        <button
          class="bg-white border-0 save-btn"
          @click="save"
        >
          <i
            class="far fa-check icon-btn"
          />
        </button>
        <button
          class="bg-white border-0"
          @click="showInput = false"
        >
          <i
            role="button"
            class="far fa-times icon-btn px-1"
          />
        </button>
      </template>
    </div>
    <div
      v-else
      class="d-flex align-items-center"
    >
      <slot />
      <i
        v-if="!disabled"
        role="button"
        class="far fa-edit ml-2"
        @click="showInput = true"
      />
    </div>
  </div>
</template>

<style scoped>
i {
  font-size: 16px;
}

input {
  min-width: 280px;
  border-right: 1px solid #dee2e6 !important;
}

.save-btn {
  border-right: 1px solid #dee2e6 !important;
}
</style>
